var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "interactive-slider",
    class: {
      'interactive-slider--push': _vm.activeSubBottomBar.length > 8
    }
  }, [_c('transition-group', {
    staticClass: "interactive-slider__slides",
    attrs: {
      "css": true
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "leave": _vm.leave,
      "afterLeave": _vm.afterLeave
    }
  }, _vm._l(_vm.activeSlides, function (slide, index) {
    return _c('div', {
      key: slide._id,
      staticClass: "interactive-slider__slide",
      class: [{
        'interactive-slider__slide--active': _vm.activeSlideId === slide._id
      }, {
        'interactive-slider__slide--active': _vm.activeSubsectionId ? _vm.activeSubsectionId === slide._id : false
      }, {
        'interactive-slider__slide--inactive': _vm.activeSlideId !== null && _vm.activeSlideId !== slide._id
      }, {
        'interactive-slider__slide--expand': _vm.activeSlideId === slide._id && slide.shouldSlideExpand
      }, {
        'interactive-slider__slide--sold-out': _vm.showSoldLabel(slide)
      }, {
        'interactive-slider__slide--filtered': slide.filtered
      }, {
        'touch': _vm.isClickable(slide)
      }],
      attrs: {
        "data-index": index
      },
      on: {
        "click": function click($event) {
          _vm.handleSlideClick(slide._id);
          _vm.triggerMedia(_vm.getSlideLabel(slide));
        }
      }
    }, [_vm.getSlideLabel(slide) ? _c('div', {
      staticClass: "interactive-slider__label",
      domProps: {
        "innerHTML": _vm._s(_vm.getSlideLabel(slide))
      }
    }) : _vm._e(), _vm.getAssetType(slide) === 'video' ? _c('video', {
      staticClass: "interactive-slider__video",
      attrs: {
        "id": "video-".concat(slide._id),
        "src": _vm.getBackgroundUrl(slide),
        "autoplay": "",
        "disablePictureInPicture": "",
        "loop": "",
        "muted": "",
        "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
      },
      domProps: {
        "muted": true
      }
    }) : _vm._e(), _vm.getAssetType(slide) === 'image' ? _c('img', {
      attrs: {
        "src": _vm.getBackgroundUrl(slide)
      }
    }) : _vm._e()]);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }